import React from "react";
import beneficio1 from '../assets/beneficio1.png'; // Adjust the path as necessary
import beneficio2 from '../assets/beneficio2.png'; // Adjust the path as necessary
import beneficio3 from '../assets/beneficio3.png'; // Adjust the path as necessary
import beneficio4 from '../assets/beneficio4.png'; // Adjust the path as necessary
import CallToAction from "./CallToAction";
function Features() {
    return (
      <div className="container features">
        <h2 className="section-title">Conoce más sobre SimVR</h2>
                
        <div className="row text-center">
            <div className="col-md-3 feature-icon">
                <img src={beneficio1} alt="Alta rotación" />
                <p>Reducción de tiempos en Capacitación</p>
            </div>
            <div className="col-md-3 feature-icon">
                <img src={beneficio2} alt="No comprenden entrenamientos" />
                <p>Altamente atractivo para nuevas generaciones laborales</p>
            </div>
            <div className="col-md-3 feature-icon">
                <img src={beneficio4} alt="Alto costo de vinculación" />
                <p>Presentar de forma segura escenarios complejos o de riesgo.</p>
            </div>
            <div className="col-md-3 feature-icon">
                <img src={beneficio3} alt="Errores por falta de experiencia" />
                <p>Aplicación offline para capacitación magistral</p>
            </div>
        </div>
        <CallToAction text="Solicita una demostración" message="Quiero solicitar una demostración de SimVR" actionId="interesado"/>
      </div>
      
    );
  }
  
  export default Features;
// import React from 'react';
